<template>
  <v-dialog
    v-model="dialog"
    :persistent="persistent"
    overlay-opacity="0"
    max-width="290"
  >
    <v-card>
      <v-card-title class="text-center">
        <Icon
          :width="24"
          class="mr-3"
          :color="'rgba(0,0,0,.54)'"
          :icon="'microphone-off'"
        />
        <Icon
          :width="24"
          class="mr-3"
          :color="'rgba(0,0,0,.54)'"
          :icon="'video-off'"
        />
        <small>{{$t('permissions.denied.noAccess')}}</small>
      </v-card-title>
      <v-card-text class="pb-0">
        <p>{{$t('permissions.denied.message1')}}</p>
        <p>{{$t('permissions.denied.message2')}}</p>
        <p class="mb-0">{{$t('permissions.denied.message3')}}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          text
          @click="goToChat()"
          v-if="!persistent"
        >
          <b>{{$t('permissions.denied.chat')}}</b>
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="handler()"
        >
          <b>{{ handlerButtonText ? handlerButtonText : $t('permissions.denied.understood') }}</b>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    handlerButtonText: {
      type: String
    },
    persistent: {
      type: Boolean,
      default: true
    }
  }
})
export default class PermissionDenied extends Vue {
  data () {
    return {
      dialog: false
    }
  }

  goToChat () {
    this.toggleDialog()
    this.$emit('openChat')
  }

  toggleDialog () {
    this.dialog = !this.dialog
  }

  handler () {
    this.dialog = false
    this.$emit('handler')
  }
}
</script>
